import { ProjectId } from "@taskin-code/contracts";
import { createFileRoute } from "@tanstack/react-router";

import { ThreadDirectoryView } from "~/components/threadDirectory/ThreadDirectoryView";
import { parseThreadDirectoryRouteSearch } from "~/lib/threadDirectoryRouteSearch";

function FocusedProjectThreadsRoute() {
  const { projectId } = Route.useParams();
  return <ThreadDirectoryView fixedProjectId={ProjectId.makeUnsafe(projectId)} />;
}

export const Route = createFileRoute("/_chat/projects/$projectId/threads")({
  validateSearch: (search) => parseThreadDirectoryRouteSearch(search),
  component: FocusedProjectThreadsRoute,
});
